<template>
  <template v-if="!item.hidden">
    <template
      v-if="
        hasOneShowingChild(item.children, item) && !onlyOneChild.children 
      "
    >
    
      <a-menu-item
       
        :key="resolvePath(onlyOneChild.path)"
      >
      <div class="ant-menu-title">
        <app-link
          v-if="onlyOneChild.meta"
          :to="resolvePath(onlyOneChild.path, onlyOneChild.query)"
        >
          <MyIcon :type="item.meta.icon" />
          <span>{{ onlyOneChild.meta.title }}</span>
        </app-link>
      </div>
      </a-menu-item>
    
    </template>

    <a-sub-menu v-else :key="item.path">
      <template #title>
        <span :key1="item.path">
          <MyIcon :type="item.meta.icon" />
          <span>{{ item.meta.title }}</span>
        </span>
      </template>

      <template v-for="child in item.children" :key="child.path" >
         <sidebar-item
            :item="child"
            :base-path="resolvePath(child.path)"
          /> 
         

          <!-- <router-link :to="resolvePath(child.path)">
					<a-menu-item v-if="child.meta"  :key="resolvePath(child.path)">{{ child.meta.title }}</a-menu-item>
				</router-link> -->


      </template> 

    </a-sub-menu>
  </template>
</template>

<script>
import { ref } from "vue";
import AppLink from "./Link";
import { isExternal } from "@/utils/validate";
import { getNormalPath } from '@/utils/ruoyi'
import path from 'path'

export default {
  name: "SidebarItem",
  props: {
    item: {
      type: Object,
      required: true,
    }, 
    basePath: {
      type: String,
      default: "",
    },
  },
  components: { AppLink },
  setup(props) {
    // data
    const onlyOneChild = ref(null);

    // methods
    const hasOneShowingChild = (children = [], parent) => {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false;
        } else {
          onlyOneChild.value = item;
          return true;
        }
      });

      // 当只有一个子路由时，默认显示该子路由
      if (showingChildren.length === 1) {
        return true;
      }

      // 如果没有子路由显示，则显示父路由
      if (showingChildren.length === 0) {
        onlyOneChild.value = { ...parent, path: "", noShowingChildren: true };
        return true;
      }

      return false;
    };

    const resolvePath = (routePath,routeQuery) => {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(props.basePath)) {
        return props.basePath;
      }
      if (routeQuery) {
        let query = JSON.parse(routeQuery);
        return { path: getNormalPath(props.basePath + '/' + routePath), query: query }
      }
      // console.log(getNormalPath(props.basePath + '/' + routePath))
      // return getNormalPath(props.basePath + '/' + routePath)
      // console.log(path.resolve(props.basePath, routePath))
      return path.resolve(props.basePath, routePath)
    };

    return {
      onlyOneChild,
      hasOneShowingChild,
      resolvePath,
    };
  },
};
</script>

<style lang="less" scoped>
/deep/.ant-menu-light {
  
  .ant-menu-item-selected {
    background-color: rgba(19, 97, 171, 0.8) !important;
    color: #ffffff;
    .ant-menu-submenu-title {
      color: #000 !important;
    }
  }
}


.anticon{
  font-size: 24px!important;
  color:#186FF2!important;
}
.router-link-exact-active{
  .anticon{
    font-size: 24px!important;
    color:#fff;
  }
}
.ant-menu-title-content{
  & > span{
    display: flex;
    align-items: center;
  }
  .ant-menu-title{
    a{
      display: flex !important;
      align-items: center;
    }
    .router-link-active{
      .anticon{
        color: #fff!important;;
      }
      
    }
  }
}
</style>